import React, { useEffect, useMemo, useState } from 'react';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow_down.svg';
import {
  Dropdown,
  DropdownItem,
  DropdownList,
  FileUploader,
  Input,
  Switch,
  Textarea
} from '@cokitchen/cokitchen-components';
import './style.scss';
import AddonCategory from './addon-category';
import AddonItem from './addon-item';
import { MealFormFieldType, MealXlsReviewComponentProps } from './types';
import { STORAGE_KEYS } from 'utils/constants';

import Select from 'components/base/select';
import { ENUM_BRAND_TYPE } from 'utils/enum';

const MealXlsReviewItem = ({
  meal,
  mealIndex,
  show,
  toggleAccordion,
  handleReviewClick,
  updateMeal,
  isReview,
  updateAddonCategory,
  updateAddon,
  baseMeals,
  brandsList
}: MealXlsReviewComponentProps) => {
  const [showAddon, setShowAddon] = useState<string | null>(null);
  const [editAddonCat, setEditAddonCat] = useState<string | null>(null);
  const [editAddon, setEditAddon] = useState<string | null>(null);

  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) as string;
  const isBudgetBrand = useMemo(
    () => brandsList?.find((b) => b.id === meal.brand?.id)?.brand_type === ENUM_BRAND_TYPE.BUDGET,
    [brandsList, meal.brand?.id]
  );
  useEffect(() => {
    if (isReview) {
      setEditAddonCat(null);
      setEditAddon(null);
    }
  }, [isReview]);
  return (
    <div
      className={`rounded-xl border border-[#EDEDEE] w-full max-w-[698px] ${
        isReview ? 'text-gray-4' : ' text-gray-6'
      }`}>
      <div
        className='py-4 px-[20px] border-b border-b-[#EDEDEE] flex cursor-pointer justify-between items-center'
        onClick={toggleAccordion}>
        <div className='flex gap-3 items-center'>
          🍔
          <p className='text-sm'>{meal.name}</p>
        </div>
        <button
          disabled={isReview || meal?.hasError}
          className={`font-medium text-sm rounded border border-[#E7E8E9] shadow py-[6px] w-[86px] flex justify-center items-center cursor-pointer hover:bg-gray-light bg-opacity-90 first-letter:first-linemarker: ${
            meal.hasError && 'text-gray-4'
          }
          `}
          onClick={() => handleReviewClick(meal)}>
          {isReview ? 'Reviewed' : 'Review'}
          {meal.hasError && <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />}
        </button>
      </div>
      {show ? (
        <div className='py-4 px-[20px]'>
          <div className='flex gap-6 flex-wrap mb-2 justify-between'>
            <div className='w-[346px]'>
              <div className='w-full mb-5'>
                <p className='text-sm font-medium mb-1'>Confirm Brand</p>
                <div className='w-full rounded border border-[#E6E5E5] py-[14px] pl-[20px] pr-[14px] flex justify-between items-center h-[50px]'>
                  <p className='text-sm'>{meal?.brand?.name || 'No brand selected'}</p>
                  <ArrowDownIcon />
                </div>
              </div>
              <div className='mb-5'>
                <div className='flex items-center gap-1'>
                  <p className='text-sm font-medium mb-2'>Item Base Meal</p>
                  {!meal.base_meal_id && <div className=' h-2 w-2  bg-red-5 rounded-full mb-2 ' />}
                </div>
                <Select
                  hasSearch
                  value={meal.base_meal_id ?? ''}
                  options={
                    baseMeals?.map((item) => {
                      return { value: item.id, text: item.name };
                    }) || []
                  }
                  placeholder='Select base meal'
                  onChange={(v) => updateMeal(mealIndex, 'text', v, 'base_meal_id')}
                />
              </div>
              <div className='w-full mb-7'>
                <div className='flex items-center'>
                  <p className='text-sm font-medium mb-1'>Confirm Meal Category</p>
                  {!meal.meal_category?.name && (
                    <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />
                  )}
                </div>

                <Dropdown
                  content={
                    <div className='w-full rounded border border-[#E6E5E5] py-[14px] pl-[20px] pr-[14px] flex justify-between items-center h-[50px]'>
                      <p className='text-sm'>
                        {meal?.meal_category?.name || 'No category selected'}
                      </p>
                      <ArrowDownIcon />
                    </div>
                  }>
                  <DropdownList className={`${isReview ? 'hidden' : 'block'}`}>
                    {meal?.meal_categories?.map((category, i) => (
                      <DropdownItem
                        key={i}
                        onClick={() =>
                          updateMeal(mealIndex, 'dropdown', null, '' as MealFormFieldType, category)
                        }>
                        {category}
                      </DropdownItem>
                    ))}
                  </DropdownList>
                </Dropdown>
                <Input
                  type='checkbox'
                  name='top'
                  checked={meal.meal_category_horizontal}
                  onChange={(e) =>
                    updateMeal(
                      mealIndex,
                      'boolean',
                      e,
                      'meal_category_horizontal' as MealFormFieldType
                    )
                  }
                  className='my-3'
                  label='Is Category Layout Horizontal ?'
                />
              </div>
              <div className='w-full mb-4'>
                <div className='flex items-center'>
                  <p className='text-sm font-medium mb-1'>Item Name</p>
                  {!meal.name && <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />}
                </div>
                <Input
                  disabled={isReview}
                  placeholder='Item Name'
                  type='text'
                  inputClass={`h-[50px] border-gray-1 ${isReview ? 'text-gray-4' : ' text-gray-6'}`}
                  value={meal.name}
                  onChange={(e) => updateMeal(mealIndex, 'text', e, 'name')}
                  className='text-sm'
                />
              </div>
              <div className='w-full mb-4'>
                <div className='flex items-center'>
                  <p className='text-sm font-medium mb-1'>Item Quantity</p>
                  {!meal.name && <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />}
                </div>
                <Input
                  disabled={isReview}
                  placeholder='Item Quantity'
                  type='text'
                  inputClass={`h-[50px] border-gray-1 ${isReview ? 'text-gray-4' : ' text-gray-6'}`}
                  value={meal.quantity}
                  onChange={(e) => updateMeal(mealIndex, 'text', e, 'quantity')}
                  className='text-sm'
                />
              </div>
            </div>
            {isBudgetBrand && (
              <Switch
                label='Mark as Budget Combo'
                active={meal.budget_combo ?? false}
                labelPosition='right'
                className='mb-2'
                onChange={(e) => {
                  updateMeal(mealIndex, 'text', e, 'budget_combo');
                }}
                switchClassName='bg-red-5'
              />
            )}
            <div className='w-[269px]'>
              <div className='w-full mb-5'>
                <FileUploader
                  token={token}
                  disabled={isReview}
                  fileUrls={meal.images ? meal.images : []}
                  setFileUrls={(imgUrl) =>
                    updateMeal(mealIndex, 'image', null, '' as MealFormFieldType, '', imgUrl)
                  }
                />
              </div>
            </div>
          </div>

          <Textarea
            disabled={isReview}
            label='Item Description'
            className='border-gray-1 text-sm mt-3'
            placeholder='item description'
            value={meal.description || ''}
            onChange={(e) => updateMeal(mealIndex, 'text', e, 'description')}
            rows={3}
          />
          <p className='text-sm font-medium mt-2 mb-3'>Add-ons</p>
          {meal?.addons?.map((addonCat, index) => {
            const idx = String(meal?.name) + String(index);
            return (
              <AddonCategory
                disabled={isReview}
                onClick={() => setShowAddon((prev) => (prev === idx ? null : idx))}
                addonCat={addonCat}
                isEdit={editAddonCat === String(idx)}
                onEditClick={() =>
                  setEditAddonCat((prev) => (prev === String(idx) ? null : String(idx)))
                }
                updateAddonCategory={(e, type) =>
                  updateAddonCategory(mealIndex, index, e, type, meal?.addons ?? [])
                }
                showAddon={showAddon === idx}
                key={index}>
                {showAddon === idx && (
                  <div className='addon_accordion_body mt-5'>
                    <div className='grid grid-cols-2 w-full gap-4'>
                      {addonCat?.addons?.map((addon, adddonIdx) => {
                        const addonIdx = String(meal?.name) + String(index) + String(adddonIdx);

                        return (
                          <AddonItem
                            disabled={isReview}
                            addon={addon}
                            key={adddonIdx}
                            isEdit={editAddon === String(addonIdx)}
                            onEditClick={() =>
                              setEditAddon((prev) =>
                                prev === String(addonIdx) ? null : String(addonIdx)
                              )
                            }
                            baseMeals={baseMeals ?? []}
                            updateAddon={(e, type) =>
                              updateAddon(mealIndex, index, adddonIdx, e, type, addonCat?.addons)
                            }
                          />
                        );
                      })}
                    </div>
                  </div>
                )}
              </AddonCategory>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default MealXlsReviewItem;
